/** @jsxImportSource @emotion/react */
import React from "react";
import * as Styles from "./styles";
import { Col, Layout, Row } from "antd";
import { SideBar, SideBarLogo, ProfileItem } from "..";

import { Constant } from "../../common/constant";
import { Images } from "../../common/images";
import { UserGroupType } from "../../services/Auth/dto/signedIn.dto";

interface LayoutDashboardProps {
  profileFirstName: string;
  profileLastName: string;
  profileImage?: string;
  logoImage?: string;
  role?: UserGroupType;
  basePath?: "admin" | "";
}

type LayoutDashboardPropsType = React.PropsWithChildren<LayoutDashboardProps>;

const LayoutDashboardComponent: React.FC<LayoutDashboardPropsType> = ({
  children,
  profileFirstName,
  profileLastName,
  profileImage,
  logoImage,
  role,
  basePath,
}: LayoutDashboardPropsType) => {
  const [inlineCollapsed, setInlineCollapsed] = React.useState(false);

  const onCollapsedClickHandle = React.useCallback(() => {
    setInlineCollapsed(!inlineCollapsed);
  }, [inlineCollapsed]);

  const [collapsedWidth, setCollapsedWidth] = React.useState(102);

  const onBreakpointHandle = React.useCallback(() => {
    if (collapsedWidth === 105) {
      setCollapsedWidth(0);
    } else {
      setCollapsedWidth(105);
    }
  }, [collapsedWidth]);

  const memoRoleName = React.useMemo(() => {
    switch (role) {
      case "SuperModerator":
        return Constant.role.superModerator;
      case "Moderator":
        return Constant.role.moderator;
      case "Sale":
        return Constant.role.sale;
      default:
        return "";
    }
  }, [role]);

  return (
    <Layout css={Styles.layoutStyle}>
      <Layout.Sider
        breakpoint="lg"
        onBreakpoint={onBreakpointHandle}
        collapsible
        collapsed={inlineCollapsed}
        width="273"
        trigger={null}
        css={Styles.containerStyle}
        collapsedWidth={collapsedWidth}
      >
        <SideBarLogo
          url={Constant.route.homeBuilder.dashboard}
          imageUrl={logoImage}
          onCollapsedClick={onCollapsedClickHandle}
          inlineCollapsed={inlineCollapsed}
        />
        <ProfileItem
          firstName={profileFirstName}
          lastName={profileLastName}
          roleName={memoRoleName}
          imageUrl={profileImage}
          inlineCollapsed={inlineCollapsed}
        />
        <SideBar role={role} basePath={basePath} />
      </Layout.Sider>
      <Layout.Header css={Styles.headerStyle}>
        <Row justify="space-between">
          <Col>
            <a href={Constant.route.homeBuilder.dashboard}>
              <img src={logoImage} />
            </a>
          </Col>
          <Col>
            <div onClick={onCollapsedClickHandle}>
              <img
                alt="collapse icon"
                src={inlineCollapsed ? Images.EXPAND : Images.COLLAPSED}
              />
            </div>
          </Col>
        </Row>
      </Layout.Header>
      <Layout.Content>{children}</Layout.Content>
    </Layout>
  );
};

export const LayoutDashboard = React.memo(LayoutDashboardComponent);
